<login-background>
    <div class="reset-sent">
        <a class="back-button" routerLink="/login" fxHide.lt-md>&lt; Back to Sign In</a>
        <header mat-dialog-title>
            <h1>Your request has been submitted.</h1>
        </header>
        Reset instructions will be sent to the provided email address if there is a matching user account in FusionPro.
    </div>
</login-background>
